import React from 'react';
import ReactDOM from 'react-dom';
import './index.less';
import { Provider } from 'react-redux'
import IRouter from './router';
import * as serviceWorker from './serviceWorker';
import configureStore from './redux/store/configureStore';
import 'lib-flexible';
import initReactFastclick from 'react-fastclick';
initReactFastclick();
const store = configureStore();
ReactDOM.render(
<Provider store={store}>
<IRouter/>
    </Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
